import { API_TIMEOUT, BaseApi as localBase } from "../interceptors/base-axios/base-axios"
import { createAsionInstance } from "../interceptors/axios/axios-instance";


const glueBaseDownlaod = createAsionInstance({
    // baseURL: "https://dads.apiservices.honeywell.com/inds-service",
        baseURL: "https://dads.api.honeywell.com/indsapi",

    timeout: API_TIMEOUT,
});


export const BaseApi = { ...localBase, glueBaseDownlaod }